module.exports = __webpack_public_path__ + "assets/img/隔空投送.4bfd680d.png";